<template>
  <el-select
    v-bind="$attrs"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    v-model="selectValue"
    filterable
    :size="size"
    :no-match-text="$t('message.common.noMatchText')"
    @change="selectChangeHandler">
    <template v-if="multiple">
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value">
        <el-checkbox @change="checkboxChangeHandler($event, index)" v-model="item.checked" style="pointer-events: none;"></el-checkbox>
        <span style="font-size: 14px;margin-left:13px;">{{ item.label }}</span>
      </el-option>
    </template>
    <template v-else>
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value">
      </el-option>
    </template>
  </el-select>
</template>
<script>
export default {
  name: 'rhcn-select',
  props: {
    value: {}, // 选中的值
    options: { // 下拉菜单选项
      type: Array,
      default: () => [],
    },
    multiple: { // 是否支持多选
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectValue: this.value,
      checked: false,
      emit: false,
    };
  },
  mounted() {
    this.initOptions();
  },
  methods: {
    checkboxChangeHandler(checked, index) {
      if (checked) {
        this.selectValue.push(this.options[index].value);
      } else {
        const findIndex = this.selectValue.indexOf(this.options[index].value);
        if (findIndex > -1) {
          this.selectValue.splice(findIndex, 1);
        }
      }
    },
    selectChangeHandler(item) {
      this.options.forEach(item => {
        if (this.selectValue.indexOf(item.value) > -1) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
      this.checked = !this.checked;
      this.$forceUpdate();
      this.updateValue();
    },
    itemChecked(val) {
      return this.selectValue.indexOf(val) > -1;
    },
    updateValue() {
      this.emit = true;
      this.$emit('update:value', this.selectValue);
      this.$emit('input', this.selectValue);
    },
    initOptions() {
      if (!this.multiple || this.emit) {
        this.emit = false;
        return;
      }
      this.selectValue = this.value;
      if (this.selectValue && this.selectValue.length) {
        this.options.forEach((item, index) => {
          if (this.selectValue.indexOf(item.value) > -1) {
            this.$set(item, 'checked', true);
          }
        });
      }
    },
  },
  watch: {
    value() {
      this.initOptions();
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.el-select {
  // multiple select
  .el-select__tags {
    padding-left: 7px;
    .el-tag {
      border: 0;
      background-color: $color-tag;
      color: $color-text-primary;
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 3px;
      margin-bottom: 3px;
      font-size: 14px;
      line-height: 26px;
      height: 26px;
      padding: 0 10px;
      .el-tag__close {
        color: $color-primary;
        background: $color-tag-delete;
        font-weight: 800;
        font-size: 14px;
        border-radius: 4px;
        display: inline-block;
        transform: none;
        margin-left: 5px;
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        line-height: 20px;
        text-align: center;
        &:hover {
          background: $color-white;
          color: $color-text-primary;
        }
        &:active {
          background: $color-tag-delete-active;
          color: $color-primary;
        }
      }
    }
    .el-select__input {
      margin-left: 6px;
    }
  }
  &:focus {
    background-color: red;
  }
  .el-input--suffix {
    &.is-focus {
      .el-input__inner {
        background-color: $color-white;
      }
    }
  }
}
</style>
